import React, { useCallback, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
    Box,
    // Button,
    Grid,
    Typography
} from "@material-ui/core";

import StyledButton from "../../../components/CustomButtons/StyledButton";
import TextFieldController from "../../../components/Controllers/TextFieldController";
import SelectController from "../../../components/Controllers/SelectController";
import { CertifRevSchema } from "../RevocacionCertificados/validations";

import { CertRevActions } from "services";

const CertificatesRevocationForm = ({ setAlertisFormValid, setSeverity, setSnackbarMessage }) => {
    const [selectedOption, setSelectedOption] = useState("");
    const [first, setFirst] = useState(true);

    const {
        control: control1,
        handleSubmit: handleSubmit1,
        setValue: setValue1,
        formState: { errors: errors1 },
    } = useForm({
        defaultValues: {
            rc_rut: "",
            rc_email: ""
        },
        mode: 'all', //  onChange | onBlur | onSubmit | onTouched | all
        resolver: yupResolver(CertifRevSchema),
    });

    const onSubmit = useCallback(async ({rc_rut, rc_email}, event) => {
        event.preventDefault();

        if (!selectedOption) return

        const success = await revocarCertificado(rc_rut, rc_email, selectedOption);

        if (success) {
            //Limpiar el formulario
            setValue1("rc_rut", "", {
                shouldValidate: false,
                shouldDirty: false
            })
            setValue1("rc_email", "", {
                shouldValidate: false,
                shouldDirty: false
            })
            setSelectedOption("")
            setFirst(true)
        }

        // // Show Notification
        setAlertisFormValid(false)

    });

    async function revocarCertificado (rut, email, motivo) {
        try {
            let desc_motivo = motivo === "revocacion-definitiva" ? "Revocación Definitiva" : "Suspensión Temporal"
            const response = await CertRevActions.revocarCertificadoPost({ "rut": rut, "email": email, "motivo": desc_motivo })

            if (response.status === 200) {
                const resultado = response.data;

                switch (resultado) {
                    case 0:
                        setSeverity('success');
                        setSnackbarMessage('Un ejecutivo se pondrá en contacto en un plazo máximo de 48 horas, para validar cuál o cuáles certificados necesita revocar. Equipo FirmaDOX.');
                      break;
                    case -1:
                        setSeverity('error');
                        setSnackbarMessage('El rut o correo ingresado no existe en nuestra base de datos, comuniquése con contacto@firmadox.cl.');
                      break;
                    case -2:
                        setSeverity('error');
                        setSnackbarMessage('Su solicitud no ha podido ser enviada, por favor inténtelo nuevamente dentro de 24 hr.');
                      break;
                    case -3:
                        setSeverity('error');
                        setSnackbarMessage('Error de base de datos o conexión, comuniquése con contacto@firmadox.cl.');
                      break;
                    default:
                        setSeverity('error');
                        setSnackbarMessage('Error al validar la persona, comuniquése con contacto@firmadox.cl.');
                      break;
                  }

                return resultado === 0;
            } else {
                setSeverity('error');
                setSnackbarMessage("Ha fallado la comunicación con el servidor.");
                return false;
            }
        } catch (error) {
            // Ocurrió un error inesperado
            console.error("Error inesperado:", error)
            setSeverity('error');
            setSnackbarMessage('Ocurrió un error inesperado.');
            return false;
        }
      }

    const getTitle = useCallback(() => {
        return <Typography style={{ fontSize: '19px', marginTop: 18 }}>Datos Personales</Typography>;
    }, []);

    const getContent = useCallback(() => {
        // console.log(first)
        return <Grid key={1} container component={'form'} onSubmit={handleSubmit1(onSubmit)}
            style={{ flexDirection: 'column' }} spacing={2}>
            <Grid item>
                <TextFieldController control={control1} label={'RUT'} name={'rc_rut'} errors={errors1}
                    autoComplete="on" />
            </Grid>

            <Grid item>
                <TextFieldController control={control1} label={'Correo Electrónico'} name={'rc_email'}
                    errors={errors1} autoComplete="on" />
            </Grid>

            <Grid item>
                <SelectController
                    label={'Tipo'}
                    control={control1}
                    errors={errors1}
                    value={selectedOption}
                    onChange={(value) => setSelectedOption(value)}
                    options={[
                      { label: 'Revocación Definitiva', value: 'revocacion-definitiva' },
                      { label: 'Suspensión Temporal', value: 'suspension-temporal' },
                    ]}
                    hasError={!selectedOption && !first}
                    setFirst={setFirst}
                  />
            </Grid>

            <Grid item style={{textAlign: "right"}}>
                <StyledButton
                    type="submit"
                    onClick={() => setFirst(false)}
                >
                    ENVIAR CORREO
                </StyledButton>
            </Grid>
        </Grid>
    }, [control1, errors1, handleSubmit1, onSubmit, selectedOption, first, setFirst]);

    return (
        <div>
            <Box display={'flex'} flexDirection={'column'} alignItems={'center'} style={{
                width: 500,
            }}>

                {getTitle()}
                <Box style={{ padding: '20px 48px', width: '100%' }}>
                    {getContent()}
                </Box>
            </Box>
        </div>
    )


}

export default CertificatesRevocationForm;
